export default ({ headingText = "Terms And Condition" }) => {
    return (
        <>
            <p>
                <h1>Privacy Policy</h1>
                <p className="updated">Last updated: March 2026</p>

                <p>Thank you for using <strong>our app</strong>.</p>

                <p>
                    This Privacy Policy explains how our application handles information when you use the app.
                </p>

                <h2>Information We Collect</h2>
                <p>
                    <strong>Our app</strong> does not collect, store, or share any personal
                    information from users.
                </p>
                <p>
                    The app does not require user accounts and does not collect personal data such as name,
                    email address, location, or contacts.
                </p>

                <h2>Advertising</h2>
                <p>
                    This app uses <strong>Google AdMob</strong> to display banner advertisements.
                </p>
                <p>
                    AdMob may collect and process certain information automatically in order to display relevant ads.
                    This information may include:
                </p>
                <ul>
                    <li>Device information</li>
                    <li>Advertising identifiers</li>
                    <li>IP address</li>
                    <li>Usage data related to ad interactions</li>
                </ul>
                <p>
                    This data is collected and processed by <strong>Google</strong>, not by us.
                </p>
                <p>
                    For more information about how Google handles data, please visit:
                    <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
                        https://policies.google.com/privacy
                    </a>
                </p>

                <h2>Data Sharing</h2>
                <p>
                    We do not sell, trade, or share any personal information with third parties.
                </p>
                <p>
                    However, third-party services such as <strong>Google AdMob</strong> may process data according
                    to their own privacy policies.
                </p>

                <h2>Children's Privacy</h2>
                <p>
                    This app is not directed to children under the age of 13.
                </p>
                <p>
                    We do not knowingly collect personal information from children.
                </p>

                <h2>Changes to This Privacy Policy</h2>
                <p>
                    We may update this Privacy Policy from time to time. Any changes will be posted on this page
                    with an updated revision date.
                </p>

                <h2>Contact</h2>
                <p>
                    If you have any questions about this Privacy Policy, please contact:
                </p>
                <p>
                    Email: <a href="mailto:admin@arrghsoft.com">admin@arrghsoft.com</a>
                </p>
            </p>
        </>
    );
};